import React, { useEffect, useState } from "react";

//UI Material
import { Breadcrumbs, Card, Grid, Link, Typography } from "@mui/material";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

//Local components
import DataLoader from "../Components/basics/DataLoader";
import ErrorBox from "../Components/ErrorBox";
import SupplierSummary from "../Components/suppliers-page/SupplierSummary";
import SupplierInfo from "../Components/suppliers-page/SupplierInfo";
import EntriesTable from "../Components/inventory-page/EntriesTable";

export default function Supplier() {
  // ==========> Component States<==========
  //State for store supplier data
  const [supplierData, setSupplierData] = useState({});
  //State for loading
  const [dataLoader, setDataLoader] = useState(false);
  //State for error case
  const [dataError, setDataError] = useState(false);

  // ==========> Component Functions <==========
  //Function to get supplier data from db
  const getSupplierData = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/inventory/get-supplier`,
        {
          id: Number(new URLSearchParams(window.location.search).get("id")),
        }
      );
      const jsonResponse = await requestResponse.json();
      setSupplierData(jsonResponse.data);
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  // ==========> Component UseEffects <==========
  //UseEffect to get product data when rendering
  useEffect(() => {
    getSupplierData();
  }, []);

  // ==========> Component <==========
  if (dataLoader) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid
      container
      spacing={1}
      justifyContent="flex-start"
      textAlign="center"
      sx={{ padding: "15px" }}
    >
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/suppliers">
            Proveedores
          </Link>
          <Link underline="hover" color="text.primary" aria-current="page">
            {`Proveedor ${new URLSearchParams(window.location.search).get(
              "id"
            )}`}
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <SupplierSummary data={supplierData} />
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Grid container spacing={1} alignItems="stretch" alignContent="stretch">
          <Grid item xs={12}>
            <SupplierInfo data={supplierData} getSupplier={getSupplierData} />
          </Grid>
          <Grid item xs={12}>
            <Card raised>
              <Grid container>
                <Grid item xs={12} sx={{ p: 2 }} align="left">
                  <Typography variant="h6" fontWeight="bold">
                    Historial de entradas
                  </Typography>
                </Grid>
                <EntriesTable method="supplier" />
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
